module.exports = __webpack_public_path__ + "img/64.535cd47f.png";